import type {
  ResetPasswordRequest,
  ResetPasswordResponse,
} from "../types/auth.type";
import type { IAuthRepository } from "../repositories/AuthRepository";
import { assertPasswordComplexity } from "../utils/passwordValidation";
import { getErrorMessage } from "../utils/errorMessage";
export interface IResetPasswordUseCase {
  execute(request: ResetPasswordRequest): Promise<ResetPasswordResponse>;
}
export class ResetPasswordUseCase implements IResetPasswordUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}
  async execute(request: ResetPasswordRequest): Promise<ResetPasswordResponse> {
    // Validate input
    if (!request.token) {
      throw new Error("Reset token is required");
    }
    if (!request.password) {
      throw new Error("Password is required");
    }
    assertPasswordComplexity(request.password);
    try {
      // Call repository to reset password
      const response = await this.authRepository.resetPassword(request);
      return response;
    } catch (error: unknown) {
      throw new Error(
        getErrorMessage(error, "Failed to reset password. Please try again."),
      );
    }
  }
}
export const createResetPasswordUseCase = (
  authRepository: IAuthRepository,
): IResetPasswordUseCase => {
  return new ResetPasswordUseCase(authRepository);
};
